import type { ConnectToAgentAction, ActionResult } from '../types/actions';

declare global {
  interface Window {
    connectToHumanAgent?: (options?: {
      reason?: string;
      activity?: 'text_chat' | 'audio' | 'audio_video';
    }) => boolean;
  }
}

export async function executeConnectToAgentAction(action: ConnectToAgentAction): Promise<ActionResult> {
  const startTime = Date.now();

  try {
    // Check if Live Help integration is available
    if (typeof window.connectToHumanAgent !== 'function') {
      return {
        success: false,
        action,
        error: 'Live Help widget not available. Please ensure the Live Help script is loaded.',
        timestamp: Date.now(),
        duration: Date.now() - startTime
      };
    }

    // Call the global connectToHumanAgent function
    const result = window.connectToHumanAgent({
      reason: action.data?.reason,
      activity: action.data?.activity
    });

    if (result) {
      return {
        success: true,
        action,
        timestamp: Date.now(),
        duration: Date.now() - startTime,
        data: {
          reason: action.data?.reason || 'User requested',
          activity: action.data?.activity || 'text_chat'
        }
      };
    } else {
      return {
        success: false,
        action,
        error: 'Failed to initiate Live Help session',
        timestamp: Date.now(),
        duration: Date.now() - startTime
      };
    }
  } catch (error) {
    return {
      success: false,
      action,
      error: error instanceof Error ? error.message : String(error),
      timestamp: Date.now(),
      duration: Date.now() - startTime
    };
  }
}
